import { currencyFormatter } from "../../../../../utils/formatter/formatter";
import { TIER_BADGE_STYLE } from "../mixQualification.data";

// Badge "TIER" 
const TierBadge = ({ tier }) => {
  const style = TIER_BADGE_STYLE[tier] || TIER_BADGE_STYLE.Cauda;
  return (
    <span style={{
      padding: "3px 10px", borderRadius: "12px", fontSize: "11px", fontWeight: "700",
      color: style.color, backgroundColor: style.bg, border: `1px solid ${style.border}`,
    }}>
      {tier}
    </span>
  );
};

const thStyle = {
  padding: "10px 12px", fontWeight: "700", color: "#888",
  fontSize: "10.5px", letterSpacing: "0.04em", whiteSpace: "nowrap",
  borderBottom: "2px solid #eee", backgroundColor: "#f8f9fb",
};
const tdStyle = { padding: "11px 12px", fontSize: "12.5px", color: "#333", borderBottom: "1px solid #f0f0f0" };

// Tabela "Ranking Empresa" 
export const RankingTable = ({ rows }) => {

  const topSales = rows[0]?.networkSales || 1;

  return (
    <div style={{ border: "1px solid #eee", borderRadius: "10px", overflow: "hidden" }}>
      {/* fundo da linha vem todo do CSS (não do inline), senão o inline
          sempre vence o :hover e o cinza nunca aparece */}
      <style>{`
        .mix-ranking-row { background-color: #fff; }
        .mix-ranking-row:hover { background-color: #f5f5f6; }
      `}</style>
      <div style={{ overflowX: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th style={{ ...thStyle, textAlign: "center", width: 40 }}>#</th>
              <th style={{ ...thStyle, textAlign: "left" }}>PRODUTO</th>
              <th style={{ ...thStyle, textAlign: "right" }}>VENDA REDE</th>
              <th style={{ ...thStyle, textAlign: "left" }}>PARTICIPAÇÃO</th>
              <th style={{ ...thStyle, textAlign: "center" }}>LOJAS</th>
              <th style={{ ...thStyle, textAlign: "center" }}>TIER</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.rank} className="mix-ranking-row">
                <td style={{ ...tdStyle, textAlign: "center", color: "#bbb" }}>{row.rank}</td>
                <td style={{ ...tdStyle, fontWeight: "600", color: "#1a1a1a" }}>{row.name}</td>
                <td style={{ ...tdStyle, textAlign: "right", fontWeight: "600" }}>{currencyFormatter.format(row.networkSales)}</td>
                <td style={{ ...tdStyle, minWidth: 160 }}>
                  <div style={{ height: 6, borderRadius: 3, background: "#f0f0f0" }}>
                    <div style={{
                      height: "100%", borderRadius: 3, backgroundColor: "#E8773A",
                      width: `${(row.networkSales / topSales) * 100}%`,
                    }} />
                  </div>
                </td>
                <td style={{ ...tdStyle, textAlign: "center", color: "#666" }}>{row.storesWithProduct}/{row.totalStores}</td>
                <td style={{ ...tdStyle, textAlign: "center" }}><TierBadge tier={row.tier} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
